import React from 'react'
import Icons from '../../assets/icons'
import GenericCustomButtton from '../../genericComponents/GenericCustomButton'
import { Trash2, TriangleAlert, X } from 'lucide-react';
import LanguageTranslator from '../../locals/LanguageTranslator';

const GenericDeleteModal = (props = {}) => {
    let {
        closeModal = () => {},
        finalSubmit = () => {},
        label = "Delete Item",
        subLabel = "This cannot be undone.",
        icon,
        topExtra,
        secondaryBtnLabel,
        primaryBtnLabel,
        renderBodyExtra=null
    } = props || {};
    return (
        <>
        {topExtra 
            ? typeof topExtra === 'function' ? topExtra() : topExtra 
            : <div className='w-full text-fontBlack px-6 py-2 bg-[#FD37571A] border-b border-[#FD375733]'>
                <div className='flex items-start gap-3'>
                    <span><TriangleAlert size={21} color='#FD3757'/></span>
                    <div>
                        <p className='mb-0 font-semibold'><LanguageTranslator tag='span'>Warning</LanguageTranslator> !</p>
                        <LanguageTranslator tag='p' className='mb-0 text-[#FD3757] text-[13px]'>This action is irreversible.</LanguageTranslator>
                    </div>
                </div>
            </div>
        }
        <div className='px-6 py-4 text-fontBlack space-y-1 flex flex-col'>
            <div className='flex items-start justify-between gap-2'>
                {icon && <div className='mb-2'>
                    {typeof(icon) == "function" ? icon() : icon}
                </div>}
                {/* <GenericCustomButtton
                    // type = "default"
                    leftIcon={<X size={17}/>}
                    onClick={() => closeModal()}
                    className={''}
                /> */}
            </div>
            <div className='flex-1 min-h-[130px]'>
                <LanguageTranslator tag='p' className='font-semibold text-lg'>{typeof label === 'function' ? label() : label}</LanguageTranslator>
                <LanguageTranslator tag='p' className='text-xs w-4/5'>{typeof subLabel === 'function' ? subLabel() : subLabel}</LanguageTranslator>
                {renderBodyExtra ? typeof renderBodyExtra === 'function' ? renderBodyExtra() : renderBodyExtra : null}
            </div>
            {/* Render the final submit button for the delete confirmation modal here */}
            <div className='flex items-center justify-end gap-3'>
                <GenericCustomButtton
                    type = "outline"
                    label = {secondaryBtnLabel ?? "Cancel"}
                    onClick = {closeModal}
                    className={'w-full max-w-[40%]'}
                />
                <GenericCustomButtton
                    type='reject'
                    loading = {props.deleteLoading}
                    label = {primaryBtnLabel ?? 'Delete'}
                    onClick = {() => {
                        finalSubmit();
                    }}
                    className={'w-full max-w-[60%]'}
                    disabled={props.deleteLoading}
                />
            </div>
        </div>
        </>
    )
}

export default GenericDeleteModal